import { Component, OnInit, OnDestroy } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";
import { LoaderService } from "./../../services";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from "../../services/login.service"
@Component({
  selector: "dlv-error",
  templateUrl: "./dlv-error.component.html",
  styleUrls: ["./dlv-error.component.scss"]
})
export class DlvErrorComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  errorTitle = "";
  errorMsg = "";
  noMsg = "";
  errorText = "";
  constructor(
    private loginService: LoginService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private loader: LoaderService
  ) { }

  ngOnInit() {
    this.loader.start();
    this.actRoute.queryParams
      .pipe(takeUntil(this.unsubscribe)).subscribe(params => {
        this.loader.stop();
        if (params && params["message"]) {
          this.setMessage(params["message"]);
        } else {
          this.router.navigate([""]);
        }
      });
  }

  setMessage = (msg) => {
    switch (msg) {
      case "access_denied":
        this.errorTitle = "Access Denied!!";
        this.errorMsg = `You don't have access to login this Application.`;
        this.loader.stop();
        break;
      case "required_login":
        this.errorTitle = "Error!!";
        this.errorMsg = "You session is expired!!, Please login.";
        this.loader.stop();
        break;
      case "login_required":
        this.errorTitle = "Login Required!!";
        this.errorMsg = `You session is expired, Please login.`;
        this.loader.stop();
        break;
      case "something":
        this.errorTitle = "Oops!!";
        this.errorMsg = "Internal Server Error.";
        this.loader.stop();
        break;
      case "time_error":
        this.errorTitle = "Crap!!";
        this.errorMsg = "There is a security issue. Looks like the date/time on your system is not synced with the internet.";
        this.errorText = "Please sync your system date time with the internet as below:"
        this.loader.stop();
        break;
      default:
        this.errorTitle = msg;
        this.errorMsg = "Somthing went wrong!";
        this.loader.stop();
    }
  };

  logout = () => {
    this.errorTitle = "";
    this.errorMsg = "";
    // 666 
    this.loginService.logOut();
    // 666 ends
  };

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
